module.exports = __webpack_public_path__ + "img/title.95827a6c.png";